// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__7twyr","tab":"tabs_tab__oBl1N","active":"tabs_active__q6lsG","items":"tabs_items__7a-Fp","content":"tabs_content__t-vps"};